import InfoList from "../../../components/InfoList/InfoList";
import Form from "../../../components/Form/Form";
import { SECTIONIDS } from "../../../constants/sectionId";
import ContactsLists from "../../../constants/contacts";
import SocialsList from "../../../constants/socials";

const ContactUsSection = () => {
  return (
    <section
      id={SECTIONIDS.CONTACT}
      className="relative z-10 bg-gradient-to-b from-black via-black/80 to-black pt-32 backdrop-blur-3xl lg:pb-32 lg:pt-0"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-12 xl:px-6 2xl:px-0">
        <div className="flex flex-wrap items-center gap-6">
          <h2 className="text-7xl font-bold text-white xl:text-8xl">
            Let's work together
          </h2>
          <span className="h-max rounded-full border border-white/40 px-2 py-1 text-xs tracking-wider text-white">
            __
          </span>
        </div>
        <div className="mt-24">
          <div className="grid gap-6 border-t border-white/30 pt-24 lg:grid-cols-3 lg:gap-24">
            <div className="lg:col-span-2">
              <Form />
            </div>
            <div className="mt-8 border border-white/30 p-8 sm:p-12">
              {<InfoList infolist={ContactsLists} />}
              {<InfoList infolist={SocialsList}/>}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUsSection;
